// extracted by mini-css-extract-plugin
export default {"calendar-custom":"styles_calendar-custom__p5EHp","overlayView":"styles_overlayView__bszN3"};